import React, {useState, useMemo, useEffect} from "react";
import {
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    TableSortLabel,
    Autocomplete, Box, Typography, Collapse, Stack, IconButton
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {styled} from "@mui/material/styles";
import {Link} from "react-router-dom";
import {useWebSocket} from "../net/WebSocketContext";
import BlurredComponent_all from "../common/BlurredComponent_all";

const ExpandMore = styled((props) => {
    const {expand, ...other} = props;
    return <IconButton {...other} />;
})(({theme}) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
    variants: [
        {
            props: ({expand}) => !expand,
            style: {
                transform: 'rotate(0deg)',
            },
        },
        {
            props: ({expand}) => !!expand,
            style: {
                transform: 'rotate(180deg)',
            },
        },
    ],
}));

const UsersControl = ({}) => {
    const { ws, isConnected, all_users_list, refresh, loading, progress } = useWebSocket();
    const [wait, setWait] = useState(false);
    const [events, setEvents] = useState([]);
    const [users, setUsers] = useState([]);
    const [openCollapse, setOpenCollapse] = useState(false)
    const [filters, setFilters] = useState(() => {
        return (
            JSON.parse(localStorage.getItem("user_controls")) ||
            {
                name: "",
                email:""
            })
    });
    useEffect(() => {
        localStorage.setItem("user_controls", JSON.stringify(filters));
    }, [filters]);
    useEffect(() => { // Пишем в WS
        if (!ws) {
            console.log("Нет готовности отправлять по ws")
            return;}
        const sendOnOpen = () => {
            setWait(true)
            ws.zsend(JSON.stringify({ action: "all_users_list" }));
            console.log("SEND:",{ action: "all_users_list" });
        };
        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };
    }, [ws]);

    useEffect(() => {
        ws.zsend(JSON.stringify({action: "all_users_list"})); // Запрашиваем список
        console.log("SEND:", {action: "all_users_list"});
    }, [refresh]);
    useEffect(() => { // Читаем WS
                        console.log("ON_MESSAGE settings", all_users_list)
                        if (all_users_list?.users) {
                            setUsers(all_users_list.users);
                        }

    },[all_users_list]);
    const handleExpandClick = () => {
        setOpenCollapse(!openCollapse);
    };
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    // // Обрабатываем пользователей
    // const getUserDanceData = (user) => {
    //     if (!user.events) return [];
    //     return Object.entries(user.events).flatMap(([eventKey, event]) => {
    //         if (!event.danceSelections) return [];
    //         return Object.entries(event.danceSelections).flatMap(([dance, categories]) => {
    //             if (!categories) return [];
    //             return Object.entries(categories).map(([category, details]) => ({
    //                 userId: user._id,
    //                 name: user.name,
    //                 email: user.email,
    //                 event: events.find(item => item?.event?.value === eventKey)?.event?.name ,
    //                 dance,
    //                 category ,
    //                 role: details.role || "-",
    //                 partner: users.find(item => item._id === details.partner)?.name || "-",
    //                 class: details.class || "-",
    //                 number: event.number? event.number+"" : "-"
    //
    //             }));
    //         });
    //     });
    // };
    //
    // // Получаем все данные
    // const allUsersData = users.flatMap(getUserDanceData);

    // Фильтрация
    const filteredData = users.filter((item) =>
        Object.entries(filters).every(([key, value]) =>
            value === "" || (item[key] && item[key].toLowerCase().includes(value.toLowerCase()))
        )
    );

    // Сортировка
    const sortedData = useMemo(() => {
        if (!sortConfig.key) return filteredData;

        return [...filteredData].sort((a, b) => {
            const valueA = a[sortConfig.key] ?? "";
            const valueB = b[sortConfig.key] ?? "";

            // Определяем тип данных
            const isNumeric = !isNaN(valueA) && !isNaN(valueB);

            if (isNumeric) {
                return sortConfig.direction === "asc"
                    ? Number(valueA) - Number(valueB)
                    : Number(valueB) - Number(valueA);
            } else {
                return sortConfig.direction === "asc"
                    ? valueA.toString().localeCompare(valueB.toString())
                    : valueB.toString().localeCompare(valueA.toString());
            }
        });
    }, [filteredData, sortConfig]);


    // Доступные значения для фильтров
    const getUniqueValues = (key) => [...new Set(users.map((item) => item[key]))];

    // Обработчик сортировки
    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc"
        }));
    };

    return (
        <Box padding={1}
        >
            <BlurredComponent_all isBlurred={(!isConnected || loading)} message={isConnected ? progress + "%" : "Все будет хорошо, но сейчас нет связи с сервером!"} />
            {/* Фильтры */}
            <Stack direction="row" spacing={2}>
            </Stack>
            <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap" }}>
                {[["name","Имя"],["email","Почта"]].map((field) => (
                    <Autocomplete
                        key={field[0]}
                        options={getUniqueValues(field[0])}
                        getOptionLabel={(option) => option}
                        value={filters[field[0]]}
                        onChange={(event, newValue) => setFilters({ ...filters, [field[0]]: newValue || "" })}
                        renderInput={(params) => <TextField {...params} label={field[1]} size="small" />}
                        style={{ width: "100%" }}
                    />
                ))}
            </div>
            {/* Таблица */}
            <TableContainer
sx={{
    margin: "auto",
    mt: 0,
    p: 0,
    overflow: 'auto',
    height: (window.innerHeight - 200) + 'px'}}
                component={Paper}>
                <Table
                    size={"small"}
                >
                    <TableHead>
                        <TableRow>
                            {[["name","Имя"],["email","Почта"]].map((col) => (
                                <TableCell key={col[0]}>
                                    <TableSortLabel
                                        active={sortConfig.key === col[0]}
                                        direction={sortConfig.direction}
                                        onClick={() => handleSort(col[0])}
                                    >
                                        {col[1]}
                                    </TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedData.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>{row.name === ""? "❌ !Не заполнено!": row.name}</TableCell>
                                <TableCell>
                                    <Typography
                                        color={"white"}
                                        component={Link}
                                        to={"/user_profile?id="+row._id}>{row.email}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default UsersControl;
